import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Link } from '@/lib/navigation';

import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';

/**
 * Crawlable row for mobile nav dropdowns — same `Link asChild` pattern as
 * `NavMegaMenuLink`, without the mega-menu grid chrome.
 *
 * Row layout is CSS-only (`[data-nav-link-row]`): `DropdownMenu.Item` passes a
 * `className` down to `Link`, which converts it into a `$$css` style entry, and
 * any sibling style values in the flattened result would be read as class names
 * rather than styles.
 */
export default function NavDropdownLink({
  href,
  label,
  isActive = false,
  icon,
  onNavigate,
}) {
  return (
    <DropdownMenu.Item asChild className="DropdownMenuItem">
      <Link href={href} asChild>
        <Pressable onPress={onNavigate} dataSet={{ navLinkRow: 'true' }}>
          {icon ? (
            <Icon name={icon} size={14} color="primary" />
          ) : isActive ? (
            <Icon name="check" size={12} color="primary" solid />
          ) : (
            <View style={styles.checkSpacer} />
          )}
          <Text size="n" color="primary" numberOfLines={1} style={styles.label}>
            {label}
          </Text>
        </Pressable>
      </Link>
    </DropdownMenu.Item>
  );
}

const styles = StyleSheet.create({
  checkSpacer: {
    width: 12,
  },
  label: {
    flex: 1,
  },
});
